export default "__VITE_ASSET__3cb2c153__"